import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  SxProps,
  Theme,
} from '@mui/material';
import { ReactNode } from 'react';

interface TableColumn<T> {
  key: string;
  header: ReactNode;
  sx?: SxProps<Theme>;
  renderCell?: (row: T, index: number) => ReactNode;
}

interface BaseTableProps<T> {
  columns: TableColumn<T>[];
  tableData: T[];
}

const BaseTable = <T,>({
  columns,
  tableData,
}: BaseTableProps<T>): JSX.Element => {
  return (
    <Table sx={{ minWidth: 650 }}>
      <TableHead>
        <TableRow>
          {columns.map((col, index) => (
            <TableCell key={index} sx={col.sx}>
              {col.header}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {tableData.map((row, i) => (
          <TableRow hover key={`row-${i}`} sx={{ height: 32 }}>
            {columns.map((col, j) => (
              <TableCell key={`cell-${i}-${j}`} sx={col.sx}>
                {col.renderCell
                  ? col.renderCell(row, i)
                  : ((row as any)[col.key] ?? '-')}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default BaseTable;
